import { useRef, type ReactNode } from "react"
import { MessageOutlined } from "@mimber/ui-web"
import { ContactSupportModal } from "@/components/modals/ContactSupportModal"
import type { PermissionedMenuItem } from "../usePermissionedMenuItems"

type MenuItemWithHandler = PermissionedMenuItem & {
  label: string
  icon: ReactNode
  onClick: () => void
}

interface UseContactSupportMenuItemResult {
  menuItem: MenuItemWithHandler
  /** Render this once outside the dropdown to back the menu item's modal. */
  modal: ReactNode
}

/**
 * Ready-made dropdown menu item + modal for submitting a Contact Support
 * request. Any dropdown can call this hook once, render `modal` outside its
 * `<Dropdown>`, and spread `menuItem` into its `items` array.
 */
export const useContactSupportMenuItem =
  (): UseContactSupportMenuItemResult => {
    const openRef = useRef<(() => void) | null>(null)

    return {
      menuItem: {
        key: "contact-support",
        icon: <MessageOutlined />,
        label: "Contact Support",
        onClick: () => openRef.current?.(),
      },
      modal: (
        <ContactSupportModal
          renderButton={(open) => {
            openRef.current = open
            return <></>
          }}
        />
      ),
    }
  }
